import { PermissionsCategory } from "src/app/auth/permissions";

@PermissionsCategory("FacilitatedAssessmentPermissions")
export class FacilitatedAssessmentPermissions {
    static readonly None = 0;
    static readonly View = 1;
    static readonly Edit = 2;
}
